import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Wrapper, MaxValues } from './styles';
import CalendarLock from '@spa/shared/svg/calendar-lock';

const MaxStay = ({ max }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      {max ? (
        <MaxValues>
          <CalendarLock />
          <span>{t('Max stay')}</span> {max ? `${max} ${t('nights')}` : t('No maximum stay')}
        </MaxValues>
      ) : null}
    </Wrapper>
  );
};

MaxStay.propTypes = {
  max: PropTypes.number.isRequired
};

export default MaxStay;
